import { ListColumn } from "./Data/ListColumn";
import { ListView } from "./Data/ListView";

export class ItemFinderListView extends ListView{

    itemFinderArrayColumns: ListColumn[];
    itemFinderTreeColumns: ListColumn[];

    constructor(items: any,  itemFinderArrayColumns: ListColumn[],itemFinderTreeColumns: ListColumn[])  {
        super();
        this.model = items;
        this.itemFinderArrayColumns = itemFinderArrayColumns;
        this.itemFinderTreeColumns = itemFinderTreeColumns;
    }

}